import React, { useState, useEffect } from "react";
import { useRating } from "../../../hooks/useRating";
import "./votar.css";
import { useAxios3 } from "../../../hooks/useAxios";
import votar_estrella_ic from "../../../assets/imgs/detalle_blog/votar_estrella_ic.png";
import { useTranslation } from "react-i18next";

const Votar = ({ friendlyTag }) => {
  const [t, i18n] = useTranslation("detail_blog");

  const [hoveredStars, setHoveredStars] = useState(0);
  const [points, setPoints] = useState(0);
  const [url2, setUrl2] = useState(`blogs/ranking/` + friendlyTag);
  const { data2, isLoading2, error2 } = useAxios3(url2);
  const [ide2, setIde2] = useState([]);

  const [formSubmitted, setFormSubmitted] = useState(false);

  const [hasVoted, setHasVoted] = useState(false);

  useEffect(() => {
    const postId = `post-${friendlyTag}`;
    // console.log(localStorage.getItem(postId));
    // console.log(typeof localStorage.getItem(postId));

    // Verificar si la cookie para este post ya existe al cargar el componente
    if (localStorage.getItem(postId) === "true") {
      setHasVoted(true);
    }
  }, [friendlyTag]);

  const handlePoints = (value) => {
    setHoveredStars(value);
    setPoints(value);
    setFormSubmitted(true);

    const postId = `post-${friendlyTag}`;

    // console.log(localStorage.getItem(postId));
    // console.log(typeof localStorage.getItem(postId));
    // Verificar si la cookie para este post ya existe
    if (localStorage.getItem(postId) === "true") {
      return;
    }

    // Establecer la cookie para este post
    localStorage.setItem(`${postId}`, true);
    // Marcar que el usuario ha votado
    setHasVoted(true);
  };

  const { data, isLoading, error } = useRating(
    formSubmitted ? "/blogs/votar" : null,
    { friendly: friendlyTag, points: points }
  );

  useEffect(() => {
    if (data) {
      console.log(isLoading);
    }
  }, [points]);

  useEffect(() => {
    if (data2) {
      setIde2(data2);
    }
  }, [data2]);

  return (
    <div className="DB_votar">
      <div className="votar_titulo">
        <h3>
          {t("votes.did-you-like")}
          {/* ¿Te gustó este blog? ¡Califícalo! */}
        </h3>
      </div>
      {hasVoted ? (
        <div className="votar_una_vez">
          <p>{t("votes.thanks")}</p>
        </div>
      ) : (
        <div className="votar_estrellas">
          <img
            src={votar_estrella_ic}
            id="star_1"
            onMouseEnter={() => setHoveredStars(1)}
            onMouseLeave={() => setHoveredStars(0)}
            onClick={() => handlePoints(1)}
            className={hoveredStars >= 1 ? "hover" : ""}
          />
          <img
            src={votar_estrella_ic}
            id="star_2"
            onMouseEnter={() => setHoveredStars(2)}
            onMouseLeave={() => setHoveredStars(0)}
            onClick={() => handlePoints(2)}
            className={hoveredStars >= 2 ? "hover" : ""}
          />
          <img
            src={votar_estrella_ic}
            id="star_3"
            onMouseEnter={() => setHoveredStars(3)}
            onMouseLeave={() => setHoveredStars(0)}
            onClick={() => handlePoints(3)}
            className={hoveredStars >= 3 ? "hover" : ""}
          />
          <img
            src={votar_estrella_ic}
            id="star_4"
            onMouseEnter={() => setHoveredStars(4)}
            onMouseLeave={() => setHoveredStars(0)}
            onClick={() => handlePoints(4)}
            className={hoveredStars >= 4 ? "hover" : ""}
          />
          <img
            src={votar_estrella_ic}
            id="star_5"
            onMouseEnter={() => setHoveredStars(5)}
            onMouseLeave={() => setHoveredStars(0)}
            onClick={() => handlePoints(5)}
            className={hoveredStars >= 5 ? "hover" : ""}
          />
        </div>
      )}
      <div className="votar_resultados">
        {isLoading2 && data2 === null ? (
          <div>
            {" "}
            <h1>cargando...</h1>
          </div>
        ) : (
          <div>
            <p>
              {t("votes.total-votes")}: {ide2.votes}{" "}
            </p>
            <p>
              {t("votes.ranking")}: {ide2.ranking}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Votar;
